import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const userMenus = (): CloudPremisePluginMenu[] => {
    let menus = [];
    return menus;
};

export default userMenus;